import { useQuery } from '@tanstack/react-query';
import styled from 'styled-components';
import { fetchTerms, Terms } from '@/api/policy';

const TermsPage = () => {
  const { data, isLoading, isError } = useQuery<Terms>({
    queryKey: ['terms'],
    queryFn: () => fetchTerms('terms'),
  });

  console.log('[🔍 정책 데이터]', data);

  if (isLoading) return <StatusText>불러오는 중...</StatusText>;
  if (isError || !data?.content) return <StatusText>정책을 불러올 수 없습니다.</StatusText>;

  return (
    <Container>
      <Title>개인정보 처리방침</Title>
      <Content dangerouslySetInnerHTML={{ __html: data.content }} />
    </Container>
  );
};

export default TermsPage;

// Styled
const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 80px 20px;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 40px;
`;

const Content = styled.div`
  font-size: 16px;
  line-height: 1.8;
  color: #3a3a3a;
  text-align: justify; // ✅ 양쪽 정렬로 보기 좋게

  p {
    margin-bottom: 16px;
  }
`;

const StatusText = styled.div`
  text-align: center;
  padding: 100px 0;
  font-size: 16px;
  color: #999;
`;
